// extracted by mini-css-extract-plugin
module.exports = {"modal":"account-page_modal__ZPNsr"};